// utils/axios.js
import axios from "axios";
import { getAccessToken, clearTokens } from "./token";

const api = axios.create({
  baseURL: "",
});

// Request interceptor
api.interceptors.request.use((config) => {
  const token = getAccessToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Endpoints où un 401 est une réponse "normale" (mauvais identifiants,
// refresh token expiré...) et ne doit donc PAS déclencher la déconnexion
// globale - sinon ça écraserait le message d'erreur du formulaire concerné.
const AUTH_ENDPOINTS_WITHOUT_AUTO_LOGOUT = [
  "/auth/login",
  "/auth/register",
  "/auth/refresh",
  "/auth/logout",
];

// Response interceptor - déconnexion + redirection automatique vers /login
// dès qu'une requête API renvoie 401 (token absent/expiré/invalide) en
// dehors des endpoints d'authentification eux-mêmes.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";

    const isAuthEndpoint = AUTH_ENDPOINTS_WITHOUT_AUTO_LOGOUT.some((endpoint) =>
      requestUrl.includes(endpoint)
    );

    if (status === 401 && !isAuthEndpoint) {
      clearTokens();

      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        try {
          sessionStorage.setItem("sessionExpired", "1");
        } catch {
          // sessionStorage indisponible (mode privé, etc.) - on ignore
        }
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;